export default "__VITE_ASSET__CoRd68Uw__"